    <div class="kt-subheader kt-grid__item">
        <div class="kt-container kt-container--fluid">
            <div class="kt-subheader__main">
                <h3 class="kt-subheader__title">
                    <span>{{ title }}</span>
                </h3>
                <span class="kt-subheader__separator kt-subheader__separator--v"></span>
                <span class="kt-subheader__desc">
                    {{ headerInfo }}
                </span>
                <div class="kt-pagination kt-pagination--brand d-none">
                    <ul class="kt-pagination__links">
                        <li class="kt-pagination__link--next">
                            <a href="#"><i class="fa fa-angle-left kt-font-brand"></i></a>
                        </li>
                        <li class="kt-pagination__link--prev">
                            <a href="#"><i class="fa fa-angle-right kt-font-brand"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="kt-subheader__toolbar">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
